// extracted by mini-css-extract-plugin
export default {"root":"FullNameTitle-module__root"};